__turbopack_context__.v({
  "insr-img-title": "linkPolicyComp-module-scss-module__Lj1hRq__insr-img-title",
  "insr-mb-btn": "linkPolicyComp-module-scss-module__Lj1hRq__insr-mb-btn",
  "insr-mb-img": "linkPolicyComp-module-scss-module__Lj1hRq__insr-mb-img",
  "insr-mb-img-title": "linkPolicyComp-module-scss-module__Lj1hRq__insr-mb-img-title",
  "insr-mb-subtitle": "linkPolicyComp-module-scss-module__Lj1hRq__insr-mb-subtitle",
  "insr-mb-txt": "linkPolicyComp-module-scss-module__Lj1hRq__insr-mb-txt",
  "insr-mb-txt-con": "linkPolicyComp-module-scss-module__Lj1hRq__insr-mb-txt-con",
  "insr-policy-subtitle": "linkPolicyComp-module-scss-module__Lj1hRq__insr-policy-subtitle",
  "insr-policy-title": "linkPolicyComp-module-scss-module__Lj1hRq__insr-policy-title",
  "insr-title-btn-con": "linkPolicyComp-module-scss-module__Lj1hRq__insr-title-btn-con",
});
